import { render } from "./Widget18.vue?vue&type=template&id=27a6a1be"
import script from "./Widget18.vue?vue&type=script&lang=js"
export * from "./Widget18.vue?vue&type=script&lang=js"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__